import type { Emitter } from 'mitt'
import mitt from 'mitt'
import type { MittType } from '@/config/types'
// 类型
export const eventBus: Emitter<MittType> = mitt<MittType>()
